module.exports = __webpack_public_path__ + "static/about-image-3_d-58e2a801c344bd7c4af5d37f6cd4e66f.jpg";